import { css } from "styled-components";

export const transition = (properties) => css`
  transition-duration: 250ms;
  transition-property: ${properties};
  transition-timing-function: ease-in;
`;
